<button
  type="button"
  class="info-tooltip-trigger"
  [attr.aria-label]="ariaLabel()"
  [matTooltip]="content()"
  [matTooltipPosition]="position()"
  matTooltipTouchGestures="on"
  #tooltip="matTooltip"
  (click)="onTriggerClick($event, tooltip)"
  (mouseenter)="onTriggerHover()">
  <mat-icon class="info-tooltip-icon" aria-hidden="true">info_outline</mat-icon>
</button>
